/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EventSceneManagementDeleteEventImageRequest } from '../models/EventSceneManagementDeleteEventImageRequest';
import type { EventSceneManagementDeleteEventImageResponseApiRespoonse } from '../models/EventSceneManagementDeleteEventImageResponseApiRespoonse';
import type { EventSceneManagementEndEventRequest } from '../models/EventSceneManagementEndEventRequest';
import type { EventSceneManagementEndEventResponseApiRespoonse } from '../models/EventSceneManagementEndEventResponseApiRespoonse';
import type { EventSceneManagementListInitRequest } from '../models/EventSceneManagementListInitRequest';
import type { EventSceneManagementListInitResponseApiRespoonse } from '../models/EventSceneManagementListInitResponseApiRespoonse';
import type { EventSceneManagementListNextRequest } from '../models/EventSceneManagementListNextRequest';
import type { EventSceneManagementListNextResponseApiRespoonse } from '../models/EventSceneManagementListNextResponseApiRespoonse';
import type { EventSceneManagementListPrevRequest } from '../models/EventSceneManagementListPrevRequest';
import type { EventSceneManagementListPrevResponseApiRespoonse } from '../models/EventSceneManagementListPrevResponseApiRespoonse';
import type { EventSceneManagementStartLotteryRequest } from '../models/EventSceneManagementStartLotteryRequest';
import type { EventSceneManagementStartLotteryResponseApiRespoonse } from '../models/EventSceneManagementStartLotteryResponseApiRespoonse';
import type { EventSceneManagementStopLotteryRequest } from '../models/EventSceneManagementStopLotteryRequest';
import type { EventSceneManagementStopLotteryResponseApiRespoonse } from '../models/EventSceneManagementStopLotteryResponseApiRespoonse';
import type { EventSceneManagementUpdateIsEditingRequest } from '../models/EventSceneManagementUpdateIsEditingRequest';
import type { EventSceneManagementUpdateIsEditingResponseApiRespoonse } from '../models/EventSceneManagementUpdateIsEditingResponseApiRespoonse';
import type { EventSceneManagementUpdateRequest } from '../models/EventSceneManagementUpdateRequest';
import type { EventSceneManagementUpdateResponseApiRespoonse } from '../models/EventSceneManagementUpdateResponseApiRespoonse';
import type { EventSceneManagementUploadEventImageRequest } from '../models/EventSceneManagementUploadEventImageRequest';
import type { EventSceneManagementUploadEventImageResponseApiRespoonse } from '../models/EventSceneManagementUploadEventImageResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EventSceneManagementEventSceneService {

    /**
     * 初期画面の情報を取得
     * @param requestBody
     * @returns EventSceneManagementListInitResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventSceneListInit(
        requestBody: EventSceneManagementListInitRequest,
    ): CancelablePromise<EventSceneManagementListInitResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event-scene/list-init',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 次の画面の情報を取得
     * @param requestBody
     * @returns EventSceneManagementListNextResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventSceneListNext(
        requestBody: EventSceneManagementListNextRequest,
    ): CancelablePromise<EventSceneManagementListNextResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event-scene/list-next',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 前の画面の情報を取得
     * @param requestBody
     * @returns EventSceneManagementListPrevResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventSceneListPrev(
        requestBody: EventSceneManagementListPrevRequest,
    ): CancelablePromise<EventSceneManagementListPrevResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event-scene/list-prev',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * イベントシーンの情報を更新
     * @param requestBody
     * @returns EventSceneManagementUpdateResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventSceneUpdate(
        requestBody: EventSceneManagementUpdateRequest,
    ): CancelablePromise<EventSceneManagementUpdateResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event-scene/update',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 準備中、発表中を更新
     * @param requestBody
     * @returns EventSceneManagementUpdateIsEditingResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventSceneUpdateIsEditing(
        requestBody: EventSceneManagementUpdateIsEditingRequest,
    ): CancelablePromise<EventSceneManagementUpdateIsEditingResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event-scene/update-is-editing',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * event_imagesを登録
     * @param requestBody
     * @returns EventSceneManagementUploadEventImageResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventSceneUploadEventImage(
        requestBody: EventSceneManagementUploadEventImageRequest,
    ): CancelablePromise<EventSceneManagementUploadEventImageResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event-scene/upload-event-image',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * event_iamgesを削除
     * @param requestBody
     * @returns EventSceneManagementDeleteEventImageResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventSceneDeleteEventImage(
        requestBody: EventSceneManagementDeleteEventImageRequest,
    ): CancelablePromise<EventSceneManagementDeleteEventImageResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event-scene/delete-event-image',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 抽選を停止
     * @param requestBody
     * @returns EventSceneManagementStopLotteryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventSceneStopLottery(
        requestBody: EventSceneManagementStopLotteryRequest,
    ): CancelablePromise<EventSceneManagementStopLotteryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event-scene/stop-lottery',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 抽選を開始
     * @param requestBody
     * @returns EventSceneManagementStartLotteryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventSceneStartLottery(
        requestBody: EventSceneManagementStartLotteryRequest,
    ): CancelablePromise<EventSceneManagementStartLotteryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event-scene/start-lottery',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * イベント終了
     * @param requestBody
     * @returns EventSceneManagementEndEventResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminEventSceneEndEvent(
        requestBody: EventSceneManagementEndEventRequest,
    ): CancelablePromise<EventSceneManagementEndEventResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/event-scene/end-event',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
